import { cn } from "@/lib/utils";
import Link from "next/link";
import { ComponentProps } from "react";

import { CurationContentCard } from "./CurationContentCard";
import { OriginalContentCard } from "./OriginalContentCard";
import { OriginalUpcomingCard } from "./OriginalUpcomingCard";
import { ContentCardScaffold } from "./scaffolds/ContentCardScaffold";

type ContentCardProps = Omit<
    ComponentProps<typeof ContentCardScaffold>,
    "content"
> & {
    /**
     * 콘텐츠 카드의 타입을 지정합니다.
     */
    type: "curation" | "original" | "upcoming";
    /**
     * 해상도를 수동으로 지정합니다. device가 없을 경우, media query를 사용하여 자동으로 변경됩니다.
     * ex. 오리지널 카드는 index 페이지에서 web+tablet으로 고정합니다.
     */
    device?: "web+tablet" | "app";
    interaction?: "hover";
    content: Mix_ContentFragment;
    onClick?: () => void;
};

export const ContentCard = ({ type, onClick, ...props }: ContentCardProps) => {
    const Component = {
        curation: CurationContentCard,
        original: OriginalContentCard,
        upcoming: OriginalUpcomingCard
    }[type];

    return (
        <Link
            className={cn(
                type === "upcoming" && "pointer-events-none"
            )}
            href={
                process.env.BUILD_TARGET === "extension"
                    ? `https://mix.day/contents/${props.content.id}`
                    : `/contents/${props.content.id}`
            }
            target={props.content.isoriginal ? "_self" : "_blank"}
            rel="noreferrer"
            onClick={onClick}
        >
            <Component {...props} />
        </Link>
    );
};
